{
  "changeLogTitle": "Registro de alterações",
  "help": {
    "tooltip": "O que é rastreado",
    "title": "O que é rastreado no registro de alterações",
    "layersCreatedDeleted": "Criações e exclusões de camadas.",
    "mapObjectsGrouped": "Mapeie criações, exclusões e edições de geometria de objetos agrupadas por usuário e hora.",
    "mapObjectEditHint": "As edições exclusivas de objetos do Mapa contam como uma edição se ocorrerem dentro de 5 minutos uma da outra.",
    "layerOperationsGrouped": "Operações de cópia, importação e desvinculação de camadas."
  },
  "dateTimes": {
    "today": "Hoje",
    "yesterday": "Ontem",
    "todayAt": "Hoje às {{ time }}",
    "yesterdayAt": "Ontem às {{ time }}",
    "dayAt": "{{ day }} em {{ time }}",
    "aWeekAgo": "Há uma semana",
    "weekday0": "domingo",
    "weekday1": "Segunda-feira",
    "weekday2": "terça",
    "weekday3": "Quarta-feira",
    "weekday4": "Quinta-feira",
    "weekday5": "Sexta-feira",
    "weekday6": "sábado"
  },
  "labels": {
    "layerFallbackName": "Camada",
    "multipleLayers": "Várias camadas",
    "viewDetails": "Exibir detalhes"
  },
  "subTitles": {
    "layerImported": "Camada importada",
    "layersImported": "Camadas importadas",
    "layerUnlinked": "Camada desvinculada",
    "layersUnlinked": "Camadas desvinculadas",
    "layerCopied": "Camada copiada",
    "layersCopied": "Camadas copiadas",
    "layerCreated": "Camada criada",
    "layerDeleted": "Camada excluída",
    "layerEdited": "Camada editada"
  },
  "details": {
    "layerImported": "Camada importada: {{ layerName }}",
    "layerUnlinked": "Camada desvinculada: {{ layerName }}",
    "layerCreated": "Camada criada: {{ layerName }}",
    "mapObjectCreated": "{{ count }} Objeto de mapa criado",
    "mapObjectsCreated": "{{ count }} Objetos de mapa criados",
    "mapObjectUpdated": "{{ count }} Objeto de mapa editado",
    "mapObjectsUpdated": "{{ count }} Objetos de mapa editados",
    "mapObjectDeleted": "{{ count }} Objeto de mapa excluído",
    "mapObjectsDeleted": "{{ count }} Objetos de mapa excluídos"
  }
}